import React from "react";
import type { ImageAttrib } from "@/types/gallery";

export default function ImageAttribution({ attrib }: { attrib?: ImageAttrib }) {
  if (!attrib) return null;

  return (
    <span>
      {attrib.prefix ? attrib.prefix + " " : null}
      {attrib.href ? (
        <a className="underline" href={attrib.href}>
          {attrib.author}
        </a>
      ) : (
        attrib.author
      )}
    </span>
  );
}
